import { common } from '@gosupersimple/types';

import {
  setVisualisationAggregations,
  visualisationKeysFromAggregation,
} from '@/explore/components/visualisation/utils';
import { AggregationsEditor } from '@/explore/edit-pipeline/aggregations-editor';
import { GroupingsEditor } from '@/explore/edit-pipeline/groupings-editor';
import { getFinalStateOrThrow } from '@/explore/pipeline/state';
import {
  AggregatedVisualisation,
  Aggregation,
  Exploration,
  Metric,
  Model,
  Pipeline,
  QueryVariables,
} from '@/explore/types';
import { metricsByModelId } from '@/explore/utils/metrics';
import { DropdownMenuItem } from '@/components/dropdown';

import formStyles from '../../../components/form/form.module.scss';

interface EditAggregatedVisualisationProps {
  visualisation: AggregatedVisualisation;
  pipeline: Pipeline;
  exploration: Exploration;
  models: Model[];
  metrics: Metric[];
  variables: QueryVariables;
  getValueKeyMenuOptions: (key: string, idx: number) => DropdownMenuItem[];
  onChange: (visualisation: AggregatedVisualisation) => void;
}

export const EditAggregatedVisualisation = (props: EditAggregatedVisualisationProps) => {
  const { visualisation, pipeline, exploration, models, metrics, variables, onChange } = props;

  const pipelineState = getFinalStateOrThrow(pipeline, {
    models,
    variables,
    metrics,
    exploration,
  });
  const availableMetrics = metricsByModelId(metrics, pipelineState.model.modelId);

  const handleAggregationsChange = (aggregations: Aggregation[]) => {
    const existingKeys = pipelineState.fields.map((f) => f.key);
    onChange(setVisualisationAggregations(visualisation, aggregations, existingKeys));
  };

  const handleGroupingsChange = (groups: common.Grouping[]) => {
    const aggregation = {
      ...visualisation.aggregation,
      groups,
    };
    onChange({
      ...visualisation,
      aggregation,
      ...visualisationKeysFromAggregation(aggregation),
    });
  };

  return (
    <div className={formStyles.formHorizontal}>
      <>
        <AggregationsEditor
          aggregations={visualisation.aggregation.aggregations}
          setAggregations={handleAggregationsChange}
          existingFields={pipelineState.fields}
          aggregationFields={pipelineState.fields}
          filterFields={pipelineState.fields}
          metrics={availableMetrics}
          autoFocus
          excludeAggregationTypes={['first', 'earliest', 'latest', 'array']}
          getMenuOptions={(aggregation, idx) =>
            props.getValueKeyMenuOptions(aggregation.property.key, idx)
          }
          variableDefinitions={[]}
        />
        <hr className={formStyles.dashed} />
        <GroupingsEditor
          fields={pipelineState.fields}
          autoFocus
          groups={visualisation.aggregation.groups}
          setGroups={handleGroupingsChange}
          preferDateGrouping={visualisation.aggregation.groups.length === 0}
        />
      </>
    </div>
  );
};
